import React, { useState, useEffect, useRef } from 'react';
import { OverlayPanel, } from 'primereact/overlaypanel'; // Import necessary components from your component library
import { Box, Typography, Grid } from '@mui/material';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Image } from 'primereact/image';
import FilterIcon from '../../assets/images/icons/filter.svg';
import { FilterMatchMode } from 'primereact/api';
import { Checkbox } from "primereact/checkbox";
import { Button } from 'primereact/button';
import AddIcon from '../../assets/images/icons/add.svg';
import ResetIcon from '../../assets/images/icons/reset.svg';
import getRequest from '../../assets/helper/ApiHandler';
import { useLocation, useNavigate } from 'react-router-dom';
import { demandColumns, demandPartnerColumns, filterOptions, routesColumns, supplyColumns, supplyPartnerColumns } from '../../assets/const/Constant';
import { ACTIVE, ARCHIVED, STOPPED } from '../../assets/const/statusConst';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '../../redux/reducer/filterslice';
import { Toast } from 'primereact/toast';
import { DEMAND, DEMAND_PARTNER, ROUTES, SUPPLY, SUPPLY_PARTNER } from '../../assets/const/reportTypeConst';
import { cloneDeep } from 'lodash';
import useInitialFilter from '../../hooks/filterHook';

const Filter = (props) => {
    const filterOverlay = useRef(null);
    const toast = useRef(null);
    const { columnsList } = props;
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showStatus, setShowStatus] = useState(true);

    const [rows, setRows] = useState([]);
    const [status, setStatus] = useState([true, true, false]);
    const initalFilters = useSelector(state => state.filters.initialFilters);
    const curFiltr = useSelector(state => state.filters.currentFilters);
    const [currentFilters, setCurrentFilters] = useState(curFiltr);
    const loc = location.pathname.split("/")[1];
    const setInitialFilter = useInitialFilter();


    useEffect(() => {
        dispatch(setFilters(initalFilters))
        setCurrentFilters(initalFilters);
        setRows([]);
        if (loc === SUPPLY_PARTNER || loc === DEMAND_PARTNER || loc === "reports") {
            setShowStatus(false);
        }
    }, [location.pathname])

    useEffect(() => {
        if (location?.state?.reportId) {
            getSavedReport(location.state.reportId);
        }
    }, [])

    useEffect(() => {
        if (rows.length === 0)
            onAddClick();
    }, [columnsList, rows])


    const getColumnsList = (type) => {
        switch (type) {
            case SUPPLY:
                return supplyColumns;
            case SUPPLY_PARTNER:
                return supplyPartnerColumns;
            case DEMAND:
                return demandColumns;
            case DEMAND_PARTNER:
                return demandPartnerColumns;
            case ROUTES:
                return routesColumns;
            default:
                return [];
        }
    };

    const getSavedReport = async (id) => {
        let filterRow = [];
        try {
            const report = await getRequest(`/ui-report-filters/${id}`, null, navigate);
            let filter = JSON.parse(report.filters);
            dispatch(setFilters(filter))
            Object.entries(JSON.parse(report.filters)).forEach(item => {
                if (item[0] !== "global") {
                    let ro = addExistingFilter(item[0], item[1].matchMode, item[1].value);
                    filterRow.push(ro);
                }
            })
            setRows(filterRow);
        } catch (error) {
            toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
    }
    const addExistingFilter = (column, type, value) => {
        let report = location.pathname.split("/")[2];
        let columnsList = getColumnsList(report);
        const newRow = {
            filterColumns: columnsList.filter(item => item.field === column)[0],
            selectedFilterType: type,
            input1Value: value,
            input2Value: ''
        };
        return newRow;
    };

    const onAddClick = () => {
        const newRow = {
            filterColumns: null,
            selectedFilterType: FilterMatchMode.EQUALS,
            input1Value: '',
            input2Value: ''
        };
        setRows([...rows, newRow]);
    };

    const handleApplyClick = () => {
        applyFilter(rows);
        filterOverlay.current.hide(); // Hide the overlay when applying
    };

    const applyFilter = () => {
        let _filters = cloneDeep(currentFilters);
        rows.forEach(item => {
            if (item.filterColumns && item.selectedFilterType) {
                if (item.selectedFilterType === FilterMatchMode.BETWEEN) {
                    _filters[item.filterColumns.field] = { value: [item.input1Value, item.input2Value], matchMode: item.selectedFilterType };
                } else {
                    _filters[item.filterColumns.field] = { value: item.input1Value, matchMode: item.selectedFilterType };
                }
            }
        });

        if (loc === SUPPLY_PARTNER || loc === DEMAND_PARTNER || loc === "reports") {
            delete _filters.isEnabled;
            delete _filters.isArchived;
        }

        dispatch(setFilters(_filters))
        setCurrentFilters(_filters)
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleOnStatusChange = (statusType, checked) => {
        let _filters = { ...currentFilters };
        let _status = [...status];
        let statusValues = [..._filters['isEnabled'].value];
        let archiveValues = [..._filters['isArchived'].value];

        switch (statusType) {
            case ACTIVE:
                if (checked) {
                    statusValues.push(true);
                    _status[0] = true;
                }
                else {
                    statusValues = statusValues.filter(val => val === false);
                    _status[0] = false;
                }
                break;
            case STOPPED:
                if (checked) {
                    statusValues.push(false);
                    _status[1] = true
                }
                else {
                    statusValues = statusValues.filter(val => val === true);
                    _status[1] = false;
                }
                break;
            case ARCHIVED:
                archiveValues = checked ? [true] : [false, null];
                statusValues = checked ? [true, false] : statusValues;
                checked ? _status = [false, false, true] : _status = [true, true, false];
                break;
            default:
                break;
        }


        _filters = {
            ...currentFilters,
            isEnabled: { value: statusValues.length > 0 ? statusValues : [null], matchMode: FilterMatchMode.IN },
            isArchived: { value: archiveValues, matchMode: FilterMatchMode.IN }
        }
        setStatus(_status);
        setCurrentFilters(_filters);
    }


    const handleCancel = () => {
        localStorage.removeItem("report")
        //setRows([])
        //dispatch(setFilters(initalFilters))
        //setCurrentFilters(initalFilters);
        //setStatus([true,true,false]);
        filterOverlay.current.hide();
    };


    const handleRemoveClick = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
        applyFilter(updatedRows);
        dispatch(setFilters(initalFilters))
        setCurrentFilters(initalFilters);

    };


    const resetFilters = () => {
        setRows([]);
        if (loc === SUPPLY_PARTNER || loc === DEMAND_PARTNER || loc === "reports") {
            setInitialFilter(initalFilters)
        }
    };


    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Button className='filter-btn' onClick={(e) => filterOverlay.current.toggle(e)}><Image src={FilterIcon} alt="Image" width="24" />Filters</Button>
            <OverlayPanel ref={filterOverlay} className='filter-panel'>
                <Box>
                    {showStatus ?
                        <Box className='panel-header'>
                            <Typography level="title-sm" className='fs-2'>Status</Typography>
                            <div className="list-item flex align-items-center">
                                <Checkbox
                                    name={ACTIVE}
                                    value={ACTIVE}
                                    disabled={status[2] ? true : false}
                                    onChange={(e) => handleOnStatusChange(e.value, e.checked)}
                                    checked={status[0]}
                                />
                                <label className="ml-2">{ACTIVE} </label>
                            </div>
                            <div className="list-item flex align-items-center">
                                <Checkbox
                                    name={STOPPED}
                                    value={STOPPED}
                                    disabled={status[2] ? true : false}
                                    onChange={(e) => handleOnStatusChange(e.value, e.checked)}
                                    checked={status[1]}
                                />
                                <label className="ml-2">{STOPPED}</label>
                            </div>
                            <div className="list-item flex align-items-center">
                                <Checkbox
                                    name={ARCHIVED}
                                    value={ARCHIVED}
                                    onChange={(e) => handleOnStatusChange(e.value, e.checked)}
                                    checked={status[2]}
                                />
                                <label className="ml-2">{ARCHIVED}</label>
                            </div>
                        </Box>
                        : ""
                    }
                    <Box className='panel-body'>
                        <Typography level="title-sm" className='fs-2'>Filter Parameter</Typography>
                        {rows.map((row, index) => (
                            <Grid container spacing={1} key={index} className='parameter-row additional-row'>
                                <Grid item xs={4}>
                                    <Dropdown
                                        value={row.filterColumns}
                                        onChange={(e) => {
                                            const updatedRows = [...rows];
                                            updatedRows[index].filterColumns = e.value;
                                            setRows(updatedRows);
                                        }}
                                        options={columnsList}
                                        optionLabel="name"
                                        placeholder="Select Column"
                                        className="w-full md:w-14rem"
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Dropdown
                                        value={row.selectedFilterType}
                                        onChange={(e) => {
                                            const updatedRows = [...rows];
                                            updatedRows[index].selectedFilterType = e.value;
                                            setRows(updatedRows);
                                        }}
                                        options={filterOptions}
                                        optionLabel="label"
                                        placeholder="Select Operator"
                                        className="w-full md:w-14rem"
                                    />
                                </Grid>
                                {(row.selectedFilterType !== FilterMatchMode.BETWEEN) ?
                                    <>
                                        <Grid item xs={3}>
                                            <InputText
                                                className='filter-parameter-input'
                                                value={row.input1Value}
                                                onChange={(e) => {
                                                    const updatedRows = [...rows];
                                                    updatedRows[index].input1Value = e.target.value;
                                                    setRows(updatedRows);
                                                }}
                                            />
                                        </Grid>
                                    </>
                                    :
                                    null
                                }
                                {row.selectedFilterType && (row.selectedFilterType === FilterMatchMode.BETWEEN) ?
                                    <>
                                        <Grid item xs={3} className='flex'>
                                            <Grid item xs={6}>
                                                <InputText
                                                    className='filter-parameter-input'
                                                    value={row.input1Value}
                                                    onChange={(e) => {
                                                        const updatedRows = [...rows];
                                                        updatedRows[index].input1Value = e.target.value;
                                                        setRows(updatedRows);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputText
                                                    className='filter-parameter-input'
                                                    value={row.input2Value}
                                                    onChange={(e) => {
                                                        const updatedRows = [...rows];
                                                        updatedRows[index].input2Value = e.target.value;
                                                        setRows(updatedRows);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                                }
                                <Grid item xs={1}>
                                    <Button type="button" className='remove-icon-btn' onClick={() => handleRemoveClick(index)}>
                                        <Image src={AddIcon} alt="Image" width="24" /></Button>
                                </Grid>
                            </Grid>
                        ))}

                    </Box>
                    <Box sx={{ minWidth: 0, display: 'left', justifyContent: 'end' }} gap={1} className="add-icon-row">
                        <Button type="button" className='add-icon-btn' onClick={onAddClick}><Image src={AddIcon} alt="Image" width="24" /></Button>
                    </Box>

                    <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'space-between' }} gap={1} className="panel-footer form-footer">
                        <Button type="button" className='add-icon-btn' onClick={resetFilters}><Image src={ResetIcon} alt="Image" width="24" /></Button>
                        <div className='action-buttons'>
                            <Button type="button" className="button-style-2" size="small" onClick={handleCancel}>Cancel</Button>
                            <Button type="button" className="button-style-1" size="small" onClick={handleApplyClick}>Apply</Button>
                        </div>
                    </Box>
                </Box>
            </OverlayPanel>
        </div >
    );
};

export default Filter;
